import React from "react";
import { NavLink, Outlet } from "react-router-dom";

const AgentSidebar = () => {
    return (
        <div className='row'>
            <div className='col-md-2'>
                <div className="sidebar">

                    <NavLink to="profile" className={({ isActive }) => isActive ? "active" : ""}>
                        My Profile
                    </NavLink>

                    <NavLink to="bride-groom-list" className={({ isActive }) => isActive ? "active" : ""}>
                        Bride/Groom List
                    </NavLink>

                    <NavLink to="new-registration" className={({ isActive }) => isActive ? "active" : ""}>
                        New Registration
                    </NavLink>

                    <NavLink to="horoscope-req-list" className={({ isActive }) => isActive ? "active" : ""}>
                        Horoscope Req List
                    </NavLink>

                    <NavLink to="membership" className={({ isActive }) => isActive ? "active" : ""}>
                        Membership
                    </NavLink>

                    <NavLink to="payments" className={({ isActive }) => isActive ? "active" : ""}>
                        Payments
                    </NavLink>

                    {/* <NavLink to="/logout">Logout</NavLink> */}
                    <a href="#">Logout</a>
                </div>
            </div>

            <div className='col-md-10'>
                <div className="contents">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default AgentSidebar;
